import * as types from 'store/mutation-types'
import choiceFilter from 'utils/choiceFilter'
import { MARKET_TYPE } from 'const/stock'

const state = {
  holdings: []
}

const mutations = {
  [types.INIT_WATCHLIST_HOLDING_LIST](state, list) {
    state.holdings = list.map(val => {
      val.digits = choiceFilter(val)
      return val
    })
  },
  [types.UPDATE_WATCHLIST_HOLDING_COR_ACTION](state, corporates) {
    (corporates || []).forEach(item => {
      const target = state.holdings.find(stock => {
        return stock.symbol === item.symbol
      })
      if (target) {
        if (target.corporates) {
          target.corporates.push(item)
        } else {
          target.corporates = [item]
        }
      }
    })
  },
  [types.UPDATE_WATCHLIST_HOLDING_LIST](state, list) {
    list.forEach(stock => {
      const existedStock = state.holdings.find(iterStock => {
        return iterStock.webLocal.symbol === stock.webLocal.symbol
      })
      if (existedStock) {
        Object.assign(existedStock, stock)
      }
    })
  }
}
const getters = {
  watchListHoldings(state) {
    return state.holdings
  }
}

const actions = {
  initWatchHoldings({ commit, dispatch }) {
    return dispatch('getUserHoldings')
      .then(holdings => {
        return holdings.filter(hold => {
          return [MARKET_TYPE.HK, MARKET_TYPE.US].includes(hold.market)
        })
      })
      .then(holdings => {
        return dispatch('getUpdatedOptionBriefs', holdings)
      })
      .then(stocks => {
        return dispatch('getUpdatedStockBriefs', stocks)
      })
      .then(stocks => {
        return dispatch('getUpdatedStockCorActions', stocks)
      })
      .then(stocks => {
        commit(types.INIT_WATCHLIST_HOLDING_LIST, stocks)
        return stocks
      })
  },
  // 刷新自选持仓
  refreshWatchHoldings({ state, commit, dispatch }) {
    return dispatch('getUpdatedOptionBriefs', state.holdings)
      .then(stocks => {
        return dispatch('getUpdatedStockBriefs', stocks)
      })
      .then(stocks => {
        commit(types.UPDATE_WATCHLIST_HOLDING_LIST, stocks)
      })
  },
  whenHoldingUpdate({ commit }, stock) {
    commit(types.UPDATE_WATCHLIST_HOLDING_LIST, [stock])
  }
}

export default { state, mutations, getters, actions }
